const t = {
  name: "Location2",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.2357 1.82153L22.1785 3.76434L14.6697 22H12.2192L10.1754 13.8247L2 11.7808V9.33035L20.2357 1.82153ZM4.68071 10.3894L11.8246 12.1754L13.6106 19.3193L19.8215 4.23575L19.7643 4.17856L4.68071 10.3894Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Location2
};
